import { Close, Search } from '@mui/icons-material';
import { IconButton, InputAdornment, InputBase } from '@mui/material';
import React from 'react';

const InputSearch = (props) => {
  const { value, onChange, ...rest } = props;

  return (
    <InputBase
      type='text'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      startAdornment={
        <InputAdornment position='start'>
          <Search fontSize='small' />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position='end'>
          <IconButton disableRipple disableTouchRipple onClick={() => onChange('')}>
            <Close fontSize='small' />
          </IconButton>
        </InputAdornment>
      }
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        borderRadius: theme.shape.borderRadius,
        padding: '6px 8px',
        bgcolor: 'background.default',
        borderWidth: '0',
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        input: {
          padding: '0',
          height: '20px',
        },
        '.MuiInputAdornment-positionEnd': {
          display: 'none',
          '.MuiButtonBase-root': {
            padding: theme.spacing(0),
            margin: theme.spacing(0),
            svg: {
              fontSize: '16px',
            },
          },
          ...(value.length !== 0 && {
            display: 'flex',
          }),
        },
      })}
      {...rest}></InputBase>
  );
};

export default InputSearch;
